import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'KanbanAPI';

export const kanbanAPI = {
  get: async (projectUUID, showNotification = true) => {
    try {
      const response = await api.get(`/${projectUUID}/kanban`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получение канбана проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении канбана проекта');
    }
  },

  post: async (projectUUID, param, showNotification = true) => {
    try {
      const response = await api.post(`/${projectUUID}/kanban/tasks`, param);
      return handleSuccessResponse(response, MODULE_NAME, 'Создание задачи в канбане', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'cоздание задачи в канбане');
    }
  },

  patch: async (projectUUID, taskID, param, showNotification = true) => {
    try {
      const response = await api.patch(`/${projectUUID}/kanban/tasks/${taskID}`, param);
      return handleSuccessResponse(response, MODULE_NAME, 'Обновление задачи', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'обновление задачи');
    }
  },

  delete: async (projectUUID, taskID, showNotification = true) => {
    try {
      const response = await api.delete(`/${projectUUID}/kanban/tasks/${taskID}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Удаление задачи', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'удаление задачи');
    }
  },

  move: async (projectUUID, taskID, param, showNotification = true) => {
    try {
      const response = await api.patch(`/${projectUUID}/kanban/tasks/${taskID}/move`, param);
      return handleSuccessResponse(response, MODULE_NAME, 'Перемещение задачи в другую колонку', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'перемещение задачи в другую колонку');
    }
  },
};